import React from 'react';
import './ServiceSingle.css';

import { Lightbox, PageTitle, SidebarHeading, Faqs } from '../../../components';
import { services } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaCheck } from 'react-icons/fa';
import { GiCakeSlice } from 'react-icons/gi';

import { Link, useLocation } from 'react-router-dom';



const ServiceSingle = () => {

  const location = useLocation();
  const service = location.state;

  const features = service.features;
  const process = service.process;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={service.title} page={"Service Single"} />

      <section className='service-single page-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all services'} />

            <div className='box-container'>
              {services.map(service => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Services/' + service.title,
                  }}
                  location = {{service}}
                  state= {service}
                  key={service.id}
                  className='item'><span><div className='icon'>{renderIcon(service.title)}</div>{service.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

        <div className='service-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={service.image} alt={service.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{service.title}</h3>

            {/* Service Content */}
            {service.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Service Image gallery */}
          <Lightbox images={service.gallery} />

          {/* Section for Service Features */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>Service Features</h3>
            <p>Discover the signature features of our {service.title}, crafted to deliver irresistible taste and delightful presentation with every bite.</p>

            {/* List of Service Features */}
            <ul>
              {features.map((feature, index) => {
                return <li key={index}>
                  <div className='icon'><FaCheck /></div>
                  {feature}
                </li>
              })}
            </ul>

          </div>

          {/* Service Process */}
          <div className='service-process sub-section'>

            <h3 className='sub-heading'>Service Process</h3>
            <p>Our {service.title} process is carefully crafted from preparation to presentation, ensuring every sweet treat is fresh, delicious, and beautifully served.</p>

            {/* List of Steps */}
            <ul>
              {process.map((step, index) => {
                return <li key={index}>
                  <div className='icon'><GiCakeSlice /></div>
                  {step}
                </li>
              })}
            </ul>

          </div>

          {/* Section for frequently asked questions */}
          <div className='service-faqs sub-section'>

            <h3 className='sub-heading'>frequently asked questions</h3>

            {/* Faq Accordion container */}
            <Faqs faqs={service.faqs} />

          </div>
        
        </div> 

      </section> 
    </> 
  );
}

export default ServiceSingle;